import { HistoryListProps } from "@husky-x/history-list";

export const HistoryMock: HistoryListProps  = {
	data: [
		{
			year: 1915,
			description: 'LA Jackson zakladá spoločnosť London Rubber Company, ktorá predáva dovážané prezervatívy a holičské doplnky.',
		},
		{
			year: 1929,
			description: 'Spoločnosť London Rubber Company (LRC) registruje značku Durex.',
		},
		{
			year: '1950s',
			description: 'Päťdesiate roky – Durex uvádza na trh prvý lubrikovaný prezervatív.',
		},
		{
			year: 1953,
			description: 'Durex ako prvý vyvíja a používa elektronické testovanie.',
		},
		{
			year: '1960s',
			description: 'Šesťdesiate roky – Durex uvádza na trh prvý anatomicky tvarovaný prezervatív.',
		},
		{
			year: '1970s',
			description: 'Sedemdesiate roky – Durex ako prvá značka prezervatívov na svete propaguje svoje výrobky v mnohých krajinách.',
		},
		{
			year: '1990s',
			description: 'Deväťdesiate roky – Durex je prvou značkou prezervatívov, ktorá si osvojila medzinárodné „záruky kvality” ako svoj štandard.',
		},
		{
			year: 1995,
			description: 'Durex uvádza na trh rad farebných a ochutených prezervatívov.',
		},
		{
			year: 1996,
			description: 'Durex ako prvá značka prezervatívov zakladá vlastné webové stránky. Teraz má 42 rôznych webových stránok v krajinách, kde má zastúpenie.',
		},
		{
			year: 1997,
			description: 'Durex uvádza na trh bezlatexové prezervatívy. Pre tieto prezervatívy bol použitý nový antialergénny materiál: syntetický polyuretán vyvinutý firmou Durex, ktorý je jemnejší a pružnejší než prírodný kaučukový latex.',
		},
		{
			year: 1998,
			description: 'Durex ako prvá značka prezervatívov vykonáva a zverejňuje celosvetový prieskum v kategórii sexuálneho zdravia.',
		},
		{
			year: 2001,
			description: 'Durex predstavuje Pleasuremax. To zo značky Durex robí prvú značku prezervatívov na svete, ktorá uvádza na trh prezervatív, ktorý je súčasne vrúbkovaný a má stimulačné výstupky.',
		},
		{
			year: 2003,
			description: 'Durex uvádza na trh rad lubrikačných gélov Play.',
		},
		{
			year: 2005,
			description: 'Durex Network zverejňuje správu Face of Global Sex, skúmajúcu aspekty sexuálneho správania. Kladie si za cieľ informovať predovšetkým akademikov a politikov.',
		},
		{
			year: 2008,
			description: 'Na propagáciu bezpečného sexu medzi mladými vyzýva Durex ľudí medzi 16 a 24 rokom na vytvorenie originálneho plagátu o sexuálnom zdraví, jazykom tínedžerov.',
		},
		{
			year: 2009,
			description: 'Durex oslavuje 80. narodeniny!',
		},
		{
			year: 2010,
			description: 'Durex podporil iniciatívu „Condomize!" Populačného Fondu Organizácie Spojených Národov na medzinárodnej konferencii o AIDS vo Viedni darom 220 000 prezervatívov.',
		},
		{
			year: 2010,
			description: 'Spoločnosť Reckitt Benckiser kupuje značku Durex.',
		},
		{
			year: 2010,
			description: 'Durex predstavuje Performax Intense prezervatív, ktorý je navrhnutý na dosiahnutie spoločného vyvrcholenia. Obsahuje 5 % benzokaín na vnútornej strane a stimulačnú vonkajšiu vrstvu. To pomáha k dlhšiemu a intenzívnejšiemu sexu.',
		},
		{
			year: 2019,
			description: 'Durex oslavuje 90. narodeniny!',
		},
	]
}